import ControlIcon from './component'

export default ControlIcon
